// components/attendance/components/PPEItemsList.js
import React from 'react';
import Icon from './appIcon';

const PPEItemsList = ({ items, type }) => {
  if (!items || items.length === 0) {
    return (
      <p className="text-sm text-muted-foreground">None</p>
    );
  }

  const getPPEIcon = (item) => {
    switch (item) {
      case 'hardhat':
        return 'Shield';
      case 'mask':
        return 'Shield';
      case 'safety_vest':
        return 'Shield';
      case 'gloves':
        return 'Shield';
      default:
        return 'Shield';
    }
  };

  const getPPELabel = (item) => {
    switch (item) {
      case 'hardhat':
        return 'Hard Hat';
      case 'mask':
        return 'Mask';
      case 'safety_vest':
        return 'Safety Vest';
      case 'gloves':
        return 'Gloves';
      default:
        return item;
    }
  };

  const getItemColor = (item) => {
    if (type === 'missing') {
      return 'text-red-600';
    }
    return 'text-green-600';
  };

  return (
    <div className="flex flex-wrap gap-2">
      {items.map((item, index) => (
        <div 
          key={index} 
          className={`flex items-center space-x-1 px-2 py-1 rounded-full text-xs ${getItemColor(item)} ${
            type === 'missing' ? 'bg-red-100' : 'bg-green-100'
          }`}
        >
          <Icon name={getPPEIcon(item)} size={12} />
          <span>{getPPELabel(item)}</span>
        </div>
      ))}
    </div>
  );
};

export default PPEItemsList;